import { render } from "./QuotaCustomUsage.vue?vue&type=template&id=ac09ded8&scoped=true"
import script from "./QuotaCustomUsage.vue?vue&type=script&lang=js"
export * from "./QuotaCustomUsage.vue?vue&type=script&lang=js"

import "./QuotaCustomUsage.vue?vue&type=style&index=0&id=ac09ded8&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac09ded8"]])

export default __exports__